import React, { Component } from 'react';
import { monitor } from '@myplay/all';
import dayjs from 'dayjs';

import { MonitorRow, TableHeader } from '..';

import './MonitorsTable.scss';

const CHECK_INTERVAL = 60000;

class MonitorsTable extends Component {
  checkInterval = null;
  state = {
    offlineMonitors: null,
    rendredMonitorIds: null
  };

  async componentDidMount() {
    await this.getOfflineMonitors();
    this.checkInterval = setInterval(()=> {
      const { offlineMonitors } = this.state;
      const rendredMonitorIds = this.getMonitorIds(offlineMonitors);
      this.setState({
        rendredMonitorIds
      },async ()=>{
        await this.getOfflineMonitors();
      })
    }, CHECK_INTERVAL)
  };

  componentWillUnmount() {
    clearInterval(this.checkInterval);
  };

  getOfflineMonitors = async () => {
    try {
      const offlineMonitors = await monitor.getOfflineMonitors();
      const monitorsWithOfflineCameras = await monitor.onlineMonitorsWithOfflineCameras();
      const modifiedMonitors = this.setLastSeenByCamerasToMonitors(monitorsWithOfflineCameras);
      const sortedMonitors = this.sortMonitorsByLastSeen([...offlineMonitors, ...modifiedMonitors]);
      this.setState({
        offlineMonitors: sortedMonitors
      });
    } catch (error) {
      console.log(error);
    }
  }

  setLastSeenByCamerasToMonitors = monitors => {
    const modifiedMonitors = [];
    monitors.map(monitor => {// eslint-disable-line
      const lastSeen = this.getLastSeenByCameras(monitor.cameras);
      const modifiedMonitor = { ...monitor };
      modifiedMonitor.lastSeen = lastSeen;
      modifiedMonitors.push(modifiedMonitor);
    });

    return modifiedMonitors;
  }

  getLastSeenByCameras = cameras => {
    let lastSeen = null;
    cameras.map(camera => {// eslint-disable-line
      if (
        dayjs(camera.lastSeen).isBefore(dayjs(lastSeen)) ||
        dayjs(camera.lastSeen).isSame(dayjs(lastSeen)) ||
        !lastSeen
      ) {
        lastSeen = camera.lastSeen
      };
    });
    return lastSeen;
  }

  sortMonitorsByLastSeen = monitors => {
    const sortedMonitors = monitors.sort((a, b) => {
      if (dayjs(a.lastSeen).isBefore(b.lastSeen) || !a.lastSeen) {
        return 1
      }

      if (dayjs(a.lastSeen).isAfter(b.lastSeen) || !b.lastSeen) {
        return -1
      }

      return 0;
    });

    return sortedMonitors;
  }

  getMonitorIds = monitors => {
    const ids = [];
    if (monitors) {
      monitors.map(monitor => ids.push(monitor.siteId));
    };
    return ids;
  }

  render() {
    const { offlineMonitors, rendredMonitorIds } = this.state;
    return (
      <div className="monitors-table">
        <TableHeader />
        {offlineMonitors &&
          offlineMonitors.map((monitor, i) =>
            <MonitorRow
              key={monitor.siteId}
              monitor={monitor}
              cameras={monitor.cameras || null}
              isNewMonitor={rendredMonitorIds !== null && !rendredMonitorIds.includes(monitor.siteId)}
              index={i}
            />
          )
        }
      </div>
    );
  };
}

export default MonitorsTable;